import React from 'react';
import { connect } from 'react-redux';
/* import clsx from "clsx"
 */ import * as builder from '../../modules/builder';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Menu from './Menu';
import PSBOffcanvas from '../../_assets/js/offcanvas';
import { Link } from 'react-router-dom';

/* 
const Container = styled.div(props => ({
  display: 'flex',
  flexDirection: props.column && 'column'
}))
 */

class AsideLeft extends React.Component {
  asideOffCanvasRef = React.createRef();
  // change the layout when Arabic lang is set
  /*   style = clsx({'ar' : this.props.lang === 'ar'})
   */ componentDidMount() {
    // eslint-disable-next-line
    /*   const PSBOffcanvas = new PSBOffcanvas(
      this.asideOffCanvasRef.current,
      this.props.menuCanvasOptions
    );  */
  }

  render() {
    return (
      <>

        <div
          id="kt_aside"
          ref={this.asideOffCanvasRef}
          className={`kt-aside  ${this.props.asideClassesFromConfig} kt-grid__item kt-grid kt-grid--desktop kt-grid--hor-desktop ${this.style}`}
        >
          {/* <Brand /> */}
          <div
            id="kt_aside_menu_wrapper"
            className="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid"
          >
            {this.props.disableScroll && (
              <Menu htmlClassService={this.props.htmlClassService} />
            )}

            <PerfectScrollbar
              options={{ wheelSpeed: 2, wheelPropagation: false }}
            >
              <Menu htmlClassService={this.props.htmlClassService} />
            </PerfectScrollbar>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (store) => ({
  lang: store.i18n.lang,
  disableAsideSelfDisplay:
    builder.selectors.getConfig(store, 'aside.self.display') === false,
  disableScroll:
    builder.selectors.getConfig(store, 'aside.menu.dropdown') === 'true' ||
    false,
  asideClassesFromConfig: builder.selectors.getClasses(store, {
    path: 'aside',
    toString: true,
  }),
  menuCanvasOptions: {
    baseClass: 'kt-aside',
    overlay: true,
    closeBy: 'kt_aside_close_btn',
    toggleBy: {
      target: 'kt_aside_mobile_toggler',
      state: 'kt-header-mobile__toolbar-toggler--active',
    },
  },
});

export default connect(mapStateToProps)(AsideLeft);
